import React from 'react';
import styled, { css } from 'styled-components/macro';
import FooterLayout  from "../components/Footer/Footer";
import { responsive } from "../resources/constantes.json";
import { useState } from 'react';
import { useRef } from 'react';
import { useLayoutEffect } from 'react';

const LayoutResultados = ({leftComponent, rightComponent}) => {
  const targetRef = useRef();
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  useLayoutEffect(() => {
    //Fix para visualizar el mapa mas grande
    const minH = React.Children.only(rightComponent).type.name === 'ResumenPorTerritorios' ? 930 : 600;
    if (targetRef.current) {
      const h = targetRef.current.offsetHeight < minH ? minH : targetRef.current.offsetHeight;
      setDimensions({
        width: targetRef.current.offsetWidth,
        height: h
      });
    }
  }, [rightComponent]);
  
  return (
    <>
      <ContainerLayout>
        <LeftSide height={dimensions.height}>{leftComponent}
        </LeftSide>
        <RightSide ref={targetRef}>{rightComponent}</RightSide>
      </ContainerLayout>
      <FooterLayout />
    </>
  );
};


const ContainerLayout = styled.div`
  display: flex; 
  @media (max-width: ${responsive.tablet}px) {
    flex-direction: column;
  }
`;
const LeftSide = styled.div`
  width: 50%;
  overflow-y: auto;
  height: ${({ height }) => height}px;
  @media (max-width: ${responsive.tablet}px) {
    width: 100%;
    overflow-y: none;
    height: auto;
    order:2;
    margin-top: 5rem;
  }
`;
const RightSide = styled.div`
  width: 50%;
  height: fit-content;
  @media (max-width: ${responsive.tablet}px) {
    width:100%;
    order:1;
  }
`;
export default LayoutResultados;
